import { Button } from '@codegouvfr/react-dsfr/Button';
import { createModal } from '@codegouvfr/react-dsfr/Modal';
import { useTextes } from '@common/config';
import {
  HabilitationChoice,
  useChooseHabilitationMutation,
  useIsTokenActiveQuery,
} from '@common/services/habilitation';
import { DangerButton } from '@common/ui';
import React, { useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApprobationHabilitationConfirmationModal } from './component/ApprobationHabilitationConfirmationModal';

export const ApprobationHabilitationPage = () => {
  const { token } = useParams();
  const t = useTextes("Inscription", "ApprobationHabilitation");

  const habilitationChoiceRef = useRef<HabilitationChoice | null>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isRefusing, setIsRefusing] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>('');

  const confirmModal = useMemo(() => createModal({
    id: 'confirm-modal',
    isOpenedByDefault: false,
  }), []);

  const [chooseHabilitation, {
    error: habilitationError,
    isSuccess: isHabilitationSuccess,
  }] = useChooseHabilitationMutation();

  const { isLoading: isTokenLoading, isError: isTokenError } = useIsTokenActiveQuery({ token });

  const refuseOrApprove = (commentaire?: string) => {
    if (!habilitationChoiceRef.current) return console.error('Le choix d\'habilitation n\'a pas été saisi.');

    chooseHabilitation({
      token,
      choice: habilitationChoiceRef.current,
      commentaire: commentaire ?? null
    });

    confirmModal.close();
  };

  const handleChoice = (choice: HabilitationChoice) => {
    habilitationChoiceRef.current = choice;

    switch (choice) {
      case HabilitationChoice.APPROBATION:
        setIsRefusing(false);
        setModalMessage('Vous êtes sur le point d\'approuver l\'habilitation, veuillez confirmer votre décision.');
        break;
      case HabilitationChoice.REFUS:
        setIsRefusing(true);
        setModalMessage('Vous êtes sur le point de refuser l\'habilitation, veuillez confirmer votre décision.');
        break;
    }

    confirmModal.open();
    setIsOpen(true);
  };

  if (isTokenLoading || isTokenError) return (
    <div className={'flex flex-col gap-4 items-center p-12 bg-[#f0f0f0]'}>
      <div className={'w-full m-auto max-w-[900px] py-[56px] px-[102px] bg-white'}>
        <div className={'flex justify-center'}>Veuillez contacter France compétences, le lien n'est plus valide.</div>
      </div>
    </div>
  );

  if (isHabilitationSuccess) return (
    <div className={'flex flex-col gap-4 items-center p-12 bg-[#f0f0f0]'}>
      <div className={'w-full m-auto max-w-[900px] py-[56px] px-[102px] bg-white'}>
        <div className={'border-1 border-solid border-[#18753C] flex '}>
          <div className={'bg-[#18753C] flex flex-col p-2'}>
                <span className={'text-white'}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z"
                      fill="white" />
                  </svg>
                </span>
          </div>

          <div className={'p-2'}>
            <span>Votre choix a bien été enregistré, vous allez recevoir un mail de confirmation.</span>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={'flex flex-col gap-4 items-center p-12 bg-[#f0f0f0]'}>

      <div className={'w-full m-auto max-w-[900px] py-[56px] px-[102px] bg-white'}>

        <p>{t['INSCR_APPR_HAB2']}</p>

        {(habilitationError) && (
          <p className={'text-red-500'}>L'habilitation a déjà été refusé ou accepté.</p>
        )}

        <div className={'flex justify-center gap-6'}>

          <DangerButton disabled={(habilitationError)}
                        onClick={() => handleChoice(HabilitationChoice.REFUS)}>REFUSER</DangerButton>

          <Button disabled={(habilitationError)}
                  onClick={() => handleChoice(HabilitationChoice.APPROBATION)}>VALIDER</Button>

          <ApprobationHabilitationConfirmationModal dsfrModal={confirmModal}
                                                    isOpen={isOpen}
                                                    message={modalMessage}
                                                    onClose={() => setIsOpen(false)}
                                                    onConfirm={refuseOrApprove}
                                                    isRefusing={isRefusing} />
        </div>
      </div>
    </div>
  );
};